<template lang="pug">
div
  UiCardSection
    UiStack
      UiStackItem(fill)
        .ui-card-section-title {{ $t("admin_tools.tabs.company_users") }}
      UiStackItem
        UiStack
          UiButton(
            @click="editUser(null)"
            icon="Plus"
          ) {{ $t("companies.users.invite_new_user") }}
          UiButton(
            @click="exportUsers()"
            icon="FileDownload"
          ) {{ $t("companies.export_to_excel") }}
          UiButton(
            @click="importUsers()"
            icon="FileUpload"
          ) {{ $t("companies.import") }}
  UiCardSection
    RestTable(
      namespace="logs"
      :headers="headers"
      ref="companyUsersTable"
      :fetch-handler="getData"
      :initial-filters="initialFilters"
      embed
    )
      template(#filters="{ filters, updateFilters }")
        UiStack
          UiStackItem
            UiFormGroup(:label="$t('admin_users.user_name')")
              UiInput(
                :modelValue="filters.search"
                type="search"
                @update:modelValue="updateFilters({ search: $event })"
                inputSize="40"
              )
          UiStackItem
            UiFormGroup(:label="$t('admin_users.company')")
              UiInput(
                :modelValue="filters.company"
                type="search"
                @update:modelValue="updateFilters({ company: $event })"
                inputSize="40"
              )
      template(#cell:actions="{ item }")
        UiStack(spacing="xs")
          UiButton(
            size="sm"
            variant="smooth-primary"
            @click="editUser(item)"
            icon="PencilCreate"
          ) {{ $t("actions.edit") }}
          UiButton(
            size="sm"
            variant="smooth-danger"
            @click="deleteCompanyUser(item)"
            icon="Trash"
          ) {{ $t("actions.delete") }}
  EditUserModal(
    ref="EditUserModal"
    @done="reload"
  )
  ImportUsersModal(
    ref="ImportUsersModal"
    @done="reload"
  )
</template>

<script>
import ApiAdminCompanyUsers from "@/api/admin_company_users.js";
import EditUserModal from "@/modals/CompanyUsers/editUser.vue";
import ImportUsersModal from "@/modals/CompanyUsers/import.vue";

export default {
  components: {
    EditUserModal,
    ImportUsersModal,
  },

  data() {
    return {
      initialFilters: {
        company: "",
      },
      headers: [
        {
          key: "id",
          label: "#",
          sortable: true,
          squeeze: true,
        },
        {
          key: "company_name",
          label: "Company",
          sortable: true,
          squeeze: true,
        },
        {
          key: "business_id",
          label: "Business ID",
          sortable: true,
          squeeze: true,
        },
        {
          key: "user_name",
          label: "Name",
          sortable: true,
          squeeze: true,
        },
        {
          key: "email",
          label: "Email",
          sortable: true,
          squeeze: true,
        },
        {
          key: "role",
          label: "Role",
          sortable: true,
          squeeze: true,
        },
        {
          key: "actions",
          label: "",
          squeeze: true,
        },
      ],
    };
  },

  methods: {
    reload() {
      this.$refs.companyUsersTable.fetchData();
    },

    getData(params, config) {
      return ApiAdminCompanyUsers.fetchUsers(params, config).then((resp) => {
        return {
          items: resp.data.users,
          meta: resp.data.meta,
        };
      });
    },

    editUser(item) {
      this.$refs.EditUserModal.open(item);
    },

    importUsers() {
      this.$refs.ImportUsersModal.open();
    },

    exportUsers() {
      ApiAdminCompanyUsers.exportUsers()
        .then((resp) => {
          let fileURL = window.URL.createObjectURL(new Blob([resp.data]));
          let fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", `company_users.xlsx`);
          document.body.appendChild(fileLink);
          fileLink.click();
        })
        .catch((e) => {});
    },

    deleteCompanyUser(item) {
      this.$dialogConfirm({
        title: this.$t("actions.remove"),
        description: this.$t("actions.confirm_remove"),
        variant: "danger",
        icon: "briefcase-remove",
        okLabel: this.$t("actions.remove"),
        okVariant: "danger",
        okIcon: "Trash",
        cancelVariant: "smooth-secondary",
      }).then((result) => {
        if (!result) return;
        ApiAdminCompanyUsers.deleteUser(item.id).then((resp) => {
          this.reloadList();
        });
      });
    },
  },
};
</script>
